module.exports = __webpack_public_path__ + "media/tdrs-intro.0ab03ccb.mp4";